import React, { useState, useEffect } from 'react';
// import PageHeading from '../PageHeading';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';

const BookingHistory = () => {
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    
    const mockBookings = [
      {
        id: 1,
        courtName: 'Court A',
        date: '2024-01-15',
        timeSlot: '10:00 AM - 11:00 AM',
        price: 7500,
        status: 'Completed'
      },
      {
        id: 2, 
        courtName: 'Court B',
        date: '2024-01-20',
        timeSlot: '2:00 PM - 3:00 PM',
        price: 7500,
        status: 'Cancelled'
      },
      {
        id: 3,
        courtName: 'Court C',
        date: '2024-01-22',
        timeSlot: '4:00 PM - 5:00 PM',
        price: 7500,
        status: 'Upcoming'
      },
      {
        id: 4,
        courtName: 'Court A',
        date: '2024-01-10',
        timeSlot: '9:00 AM - 10:00 AM',
        price: 7500,
        status: 'Cancelled'
      },
      {
        id: 5,
        courtName: 'Court B',
        date: '2024-01-05',
        timeSlot: '3:00 PM - 4:00 PM',
        price: 7500,
        status: 'Completed'
      },
      {
        id: 6,
        courtName: 'Court C',
        date: '2024-01-25',
        timeSlot: '5:00 PM - 6:00 PM',
        price: 7500,
        status: 'Upcoming'
      },
      {
        id: 7,
        courtName: 'Court A',
        date: '2024-01-08',
        timeSlot: '11:00 AM - 12:00 PM',
        price: 7500,
        status: 'Completed'
      },
      {
        id: 8,
        courtName: 'Court B',
        date: '2024-01-28',
        timeSlot: '1:00 PM - 2:00 PM',
        price: 7500,
        status: 'Upcoming'
      }
    ];
    setBookings(mockBookings);
  }, []);

  return (
    <>
      <style>
        {`
          .table>:not(caption)>*>* {
            padding: 1.5rem .5rem;
          }
        `}
      </style>
      
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Your Court Booking History"
        subTitle="Booking history"
        variant="text-center"
        shape="shape_1"
      />
      <Spacing lg="25" md="60" />
      <Spacing lg="50" md="80" />
      <div className="container">
        <div className="cs_card cs_style_1 bg-dark">
          <div className="cs_card_in">
            {bookings.length === 0 ? (
              <div className="text-center p-4 text-light">
                <h3>No booking history found</h3>
              </div>
            ) : (
              <div className="table-responsive w-100">
                <table 
                  className="table table-dark table-hover" 
                  style={{ 
                    minWidth: '900px',
                    '& > :not(caption) > * > *': {
                      padding: '1.5rem 1.5rem'
                    }
                  }}
                >
                  <thead>
                    <tr className="text-light">
                      <th scope="col" style={{ whiteSpace: 'nowrap', paddingLeft: '20px' }}>Booking ID</th>
                      <th scope="col" style={{ whiteSpace: 'nowrap' }}>Court</th>
                      <th scope="col" style={{ whiteSpace: 'nowrap' }}>Date</th>
                      <th scope="col" style={{ whiteSpace: 'nowrap' }}>Time Slot</th>
                      <th scope="col" style={{ whiteSpace: 'nowrap' }}>Price</th>
                      <th scope="col" style={{ whiteSpace: 'nowrap' }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bookings.map((booking) => (
                      <tr key={booking.id} className="text-light">
                        <td style={{ whiteSpace: 'nowrap', paddingLeft: '20px' }}>#{booking.id}</td>
                        <td style={{ whiteSpace: 'nowrap' }}>{booking.courtName}</td>
                        <td style={{ whiteSpace: 'nowrap' }}>{booking.date}</td>
                        <td style={{ whiteSpace: 'nowrap' }}>{booking.timeSlot}</td>
                        <td style={{ whiteSpace: 'nowrap' }}>Rs:{booking.price}</td>
                        <td style={{ whiteSpace: 'nowrap' }}>
                          <span 
                            className={`badge ${
                              booking.status === 'Completed' 
                                ? 'bg-success' 
                                : booking.status === 'Cancelled'
                                ? 'bg-danger'
                                : 'bg-primary'
                            } rounded-pill`}
                          >
                            {booking.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
    </>
  );
}

export default BookingHistory;
